import useComputed from '@/hooks/use-computed'
import api from '@/services/api/enrolment.js'
import titleCase from '@/utils/title-case'
import { immerable } from "immer"
import { uniqBy } from 'lodash'
import { useState } from 'react'

class Enrolments {

	[immerable] = true

	constructor(params) {
		this.id = params.id
		this.type = params.type
		this.status = params.status
		this.system = params.system
		this.organization = params.organization
		this.is3rdParty = params.is3rdParty
		this.dataElement = params.dataElement
		this.dateRequested = params.dateRequested
		this.requiredFields = params.requiredFields
		this.useCase = params.useCase
		this.useCaseId = params.useCaseId
		this.$selected = false
		this.$requestStatus = ""
	}
}

const useEnrolments = () => {

	const [itemsEnrolment, setItemsEnrolment] = useComputed([])

	const [metaEnrolment, setMetaEnrolment] = useState(null)

	const [currentItemEnrolment, setCurrentItemEnrolment] = useState(null)
	const [loadingEnrolment, setLoadingEnrolment] = useState(false)
	const [errorEnrolment, setErrorEnrolment] = useState();
	const [agentEnrolmentExist, setAgentEnrolmentExist] =  useState(false);

	async function fetchEnrolment(parameter) {
		setLoadingEnrolment(true)

		const params = parameter ? parameter : "";

		const [errorResponse, dataResponse] = await api.index({
			params
		})

		setLoadingEnrolment(false)

		if (errorResponse) {
			return setErrorEnrolment(errorResponse)
		}

		const { meta } = dataResponse

		if (!Array.isArray(dataResponse.items)) {
			return setErrorEnrolment('Enrolments is not an array')
		}

		const serializedData = dataResponse.items.map(entry => serialize(entry))
		const newItems = serializedData.map(data => new Enrolments(data))
		setMetaEnrolment(meta)
		return setItemsEnrolment(newItems)
	}

	async function findEnrolment(parameter) {
		setLoadingEnrolment(true)

		const params = parameter ? parameter : "";

		const [errorResponse, dataResponse] = await api.index({
			params
		})

		setLoadingEnrolment(false)

		if (errorResponse) {
			return setErrorEnrolment(errorResponse)
		}

		if (!Array.isArray(dataResponse.items)) {
			return setErrorEnrolment('Enrolments is not an array')
		}

		const serializedData = dataResponse.items.map(entry => serialize(entry))
		return serializedData.map(data => new Enrolments(data))
	}

	async function findUniqueEnrolment(parameter) {
		setLoadingEnrolment(true)

		const params = parameter ? parameter : "";

		const [errorResponse, dataResponse] = await api.index({
			params
		})

		setLoadingEnrolment(false)

		if (errorResponse) {
			return setErrorEnrolment(errorResponse)
		}

		const { meta } = dataResponse

		if (!Array.isArray(dataResponse.items)) {
			return setErrorEnrolment('Enrolments is not an array')
		}

		const uniqueData = uniqBy(dataResponse.items, "organization.id")

		const serializedData = uniqueData.map(entry => serialize(entry))
		const newItems = serializedData.map(data => new Enrolments(data))
		setMetaEnrolment(meta)
		return setItemsEnrolment(newItems)
	}

	async function checkAgentEnrolmentExist(params) {
		setLoadingEnrolment(true);

		const [errorResponse, dataResponse] = await api.checkAgentEnrolmentExist({params});

		setLoadingEnrolment(false);

		if (errorResponse) {
			return setErrorEnrolment('Failed to check existing enrolments')
		}
		
		setAgentEnrolmentExist(dataResponse.agentEnrolmentExist ?? false)
	}

	function serialize(entry) {
		return {
			id: entry.id,
			type: titleCase(entry.type),
			status: entry.status,
			system: entry.systems,
			organization: entry.organization,
			is3rdParty: entry.is3rdParty,
			dataElement: entry.dataElement,
			dateRequested: entry.dateRequested,
			requiredFields: entry.requiredFields,
			useCase: entry.useCase,
			useCaseId: entry.useCaseId,
		}
	}

	function viewEnrolment(id) {
		const newCurrentItem = itemsEnrolment.find(item => item.id === id)
		setCurrentItemEnrolment(newCurrentItem)
	}

	return {
		errorEnrolment,
		fetchEnrolment,
		itemsEnrolment,
		currentItemEnrolment,
		setCurrentItemEnrolment,
		loadingEnrolment,
		setItemsEnrolment,
		viewEnrolment,
		findEnrolment,
		metaEnrolment,
		findUniqueEnrolment,
		checkAgentEnrolmentExist,
		agentEnrolmentExist
	}

}

export default useEnrolments;
